import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Twitter, Facebook, Youtube, Heart } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { footerContent } from '../data/mock';

const socialIconMap = {
  Instagram: Instagram,
  Twitter: Twitter,
  Facebook: Facebook,
  Youtube: Youtube
};

const Footer = () => {
  const { language } = useLanguage();

  return (
    <footer className="bg-gradient-to-b from-[#1a3334] to-[#0d1f1f] border-t border-gray-800">
      <div className="max-w-[1400px] mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 mb-12">
          {/* Brand Section */}
          <div className="lg:col-span-2 space-y-6">
            <div className="flex items-center space-x-2">
              <div className="text-2xl font-bold text-white tracking-tight">
                <span className="text-white">THE</span>
                <span className="text-emerald-400 ml-1">WALLNESS</span>
              </div>
              <div className="h-6 w-1 bg-emerald-400"></div>
            </div>
            <p className="text-gray-400 leading-relaxed max-w-md">
              {language === 'en' ? footerContent.description_en : footerContent.description_es}
            </p>
            {/* Social Links */}
            <div className="flex space-x-4">
              {footerContent.social.map((social) => {
                const Icon = socialIconMap[social.icon];
                return (
                  <a
                    key={social.platform}
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-10 h-10 rounded-full bg-gray-800/50 border border-gray-700 flex items-center justify-center text-gray-400 hover:text-emerald-400 hover:border-emerald-400 hover:bg-emerald-400/10 transition-all duration-300"
                  >
                    <Icon className="w-5 h-5" />
                  </a>
                );
              })}
            </div>
          </div>

          {/* Links Sections */}
          {footerContent.sections.map((section) => (
            <div key={section.title_en} className="space-y-4">
              <h3 className="text-white font-semibold text-lg">
                {language === 'en' ? section.title_en : section.title_es}
              </h3>
              <ul className="space-y-3">
                {section.links.map((link) => (
                  <li key={link.path}>
                    <Link
                      to={link.path}
                      className="text-gray-400 hover:text-emerald-400 transition-colors duration-200 text-sm"
                    >
                      {language === 'en' ? link.label_en : link.label_es}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-500 text-sm">
              {language === 'en' ? footerContent.copyright_en : footerContent.copyright_es}
            </p>
            <div className="flex items-center space-x-2 text-gray-500 text-sm">
              <span>{language === 'en' ? 'Made with' : 'Hecho con'}</span>
              <Heart className="w-4 h-4 text-emerald-400 fill-emerald-400" />
              <span>{language === 'en' ? 'for women athletes' : 'para mujeres atletas'}</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;